import {Directive, ElementRef, HostListener, Input} from '@angular/core';
export class OnlyNumberDirective {

    
    onlyNumber: boolean;

    regexStr = '^[0-9]*$';
/**
 * @param {?} el
 */
constructor(private el: ElementRef) {
    }
/**
 * @param {?} event
 * @return {?}
 */
onKeyDown(event: KeyboardEvent) {
        let /** @type {?} */ e = /** @type {?} */(( <KeyboardEvent> event));
        if (this.onlyNumber) {
            if (
                [46, 8, 9, 27, 13, 110, 190, 171].indexOf(e.keyCode) !== -1 ||
                // Allow: Ctrl+A
                (e.keyCode === 65 && e.ctrlKey === true) ||
                // Allow: Ctrl+C
                (e.keyCode === 67 && e.ctrlKey === true) ||
                // Allow: Ctrl+V
                (e.keyCode === 86 && e.ctrlKey === true) ||
                // Allow: Ctrl+X
                (e.keyCode === 88 && e.ctrlKey === true) ||
                // Allow: home, end, left, right
                (e.keyCode >= 35 && e.keyCode <= 39) ||
                // Allow plus button
                (e.keyCode === 107) || (e.keyCode === 187)) {
                // let it happen, don't do anything
                return;
            }
            let /** @type {?} */ ch = String.fromCharCode(e.keyCode);
            let /** @type {?} */ regEx = new RegExp(this.regexStr);
            if (regEx.test(ch)) {
                return;
            } else if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        } else {
            return;
        }
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: '[onlyNumber]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onlyNumber': [{ type: Input },],
'onKeyDown': [{ type: HostListener, args: ['keydown', ['$event'], ] },],
};
}

function OnlyNumberDirective_tsickle_Closure_declarations() {
/** @type {?} */
OnlyNumberDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OnlyNumberDirective.ctorParameters;
/** @type {?} */
OnlyNumberDirective.propDecorators;
/** @type {?} */
OnlyNumberDirective.prototype.onlyNumber;
/** @type {?} */
OnlyNumberDirective.prototype.regexStr;
/** @type {?} */
OnlyNumberDirective.prototype.el;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
